import React from "react";
import { useEffect, useState } from "react";
import { setGoHome, setLoader } from "../../action/homeAction";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel} from "../../JS/utility";
import { CMSPath } from "../../../config/constant";
import { sendAnalytics } from "../../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import moment from "moment";
import { scrollToTop } from "../../../JS/scrollToTop";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { popupOpenClose } from "../../../action/action";
import MiniLoader from "../../UI/MiniLoader";
import Event_CancelReservation from "./Event_CancelReservation";
import { filterEvent, isFirstReservation, neccessaryFieldsForReservationPresent } from "./helpers";

const getNameOfInventory=(events,venueId,inventoryId)=>{
    let inventory_name="";
    events.forEach((e)=>{
        if(e.venueId==venueId){
            for(const inventory of e.inventories){
                if(inventory.id==inventoryId)
                {
                    inventory_name=inventory.inventory_name;
                     break;
                }
            }
        }
         
    })
    return inventory_name;

}

function Event2_MyReservations(props) {
    const { t } = props;
    // const [isfetchingReservation, setIsfetchingReservation] = useState(false);
    const [cancelAppointmentId, setCancelAppointmentId] = useState(null);


     const filterEvent=(data)=>{
        const id=props.selectedEvent.eventId;
        if(!data)return data;
        console.log("data of filterEvent()", data);
        return data.filter((d)=>d.event.event_id==id)
        
    }

    const formatDate = (dateString) => {
        console.log(dateString, "dateString");
        const date = new Date(dateString);
        const today = props.serverTimeDate
            ? new Date(props.serverTimeDate.split("T")[0])
            : new Date();

        // Clear the time part for comparison
        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);

        const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
        const diffInTime = date.getTime() - today.getTime();
        const diffInDays = diffInTime / oneDayInMilliseconds;

        if (diffInDays === 0) {
            return "Today";
        } else if (diffInDays === -1) {
            return "Yesterday";
        } else if (diffInDays === 1) {
            return "Tomorrow";
        } else {
            return `${moment(new Date(dateString)).format(props.dateFormat.toUpperCase())}`

        }
    };

    const groupingByDate = (data) => {
        const groupedAccToDay = new Map();

        data.sort((a, b) => {
            return (
                new Date(a.real_datetime_of_slot).getTime() -
                new Date(b.real_datetime_of_slot).getTime()
            );
        });
        console.log(data);
        data.forEach((d) => {
            const groupingKey = formatDate(d.date);
            if (groupedAccToDay.has(groupingKey)) {
                const keyData = groupedAccToDay.get(groupingKey);
                keyData.push(d);
            } else {
                groupedAccToDay.set(groupingKey, [d]);
            }
        });

        console.log(groupedAccToDay, "groupedAccToDay");
        return groupedAccToDay;
    };

    const handleDeleteReservation = (bool, msg) => {

        setCancelAppointmentId(null)
        
        if (bool) {
          props.closeOrderPopUp(true, t('events.success.successful_res_cancelled'), "", false)
        }
        else {
          console.log('would show closeorderpopup now')
          props.closeOrderPopUp(true, msg || t('events.failure.fail_res_cancelled'), "", true)
        }
        props.fetchMyReservations(7);
      
      
      }

    useEffect(() => {
        scrollToTop();
    }, [])

    return (<>

    {
        !cancelAppointmentId
        &&

   
        <header className="inner-pages w-footer subpages">
            <a className="button-back" onClick={props.back}></a>
            <div className="heading align-center">
                <div class="splash-brand">
                    <img src={`${CMSPath}${props.logo}`} />
                </div>
            </div>
        </header>

}

        {
            
            <section className="widgets padding-0 margin-0 container-bg">

                <section class="widgets spa-listing spa-details">
                    <>
                        <div class="widget-header">
                            {props.currentWidgetObj.widgetHeaderImageUrl && (
                                <div class="widget-header-img">
                                    <img
                                        src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                                        alt={props.currentWidgetObj.displayName}
                                    />
                                </div>
                            )}
                            <div class="widget-header-title">
                                {props.selectedEvent.eventName }
                                {/* Your Reservations */}
                            </div>
                            <div class="widget-header-subtitle">
                                {t("events.subtitle2")
                                }
                            </div>
                        </div>

                        <div class="widgets">
                            <div class="gallery-slides itinerary-list">
                                <div class="form-row-heading">
                                    {`${t("events.myReservation")}${filterEvent(props.myReservations) && filterEvent(props.myReservations).length > 1 ? "s" : ""
                                        }`}
                                </div>

                                {props.isFetchingMyReservation ? (
                                    <MiniLoader/>
                                ) :
                                    (
                                      filterEvent(props.myReservations)
                                            ?
                                            (
                                                filterEvent(props.myReservations).length > 0
                                                    ?
                                                    <>
                                                        {Array.from(
                                                            groupingByDate(filterEvent(props.myReservations)).entries()
                                                        ).map(([day, dataOnThatDay]) => {
                                                            return (
                                                                <div class="list-items-container">
                                                                    <div class="list-item-heading">{day}</div>
                                                                    {dataOnThatDay.map((reservation) => {
                                                                        return (
                                                                            <div class="list-item">
                                                                                <div class="list-item-contents">

                                                                                     <div class="list-item-name">{getNameOfInventory(props.selectedEvent.events,reservation.venue_id,reservation.event.inventory_id)}</div>

                                                                                    <div class="list-item-body">
                                                                                    {
                                                                                        formatLocalTime(new Date(reservation.real_datetime_of_slot), toBool(props.timeFormat))
                                                                                     }
                                                                                    </div> 
                                                                                    
                                                                                     
                                                                                </div>




                                                                                <div class="list-item-opt">
                                                                                    {reservation.status!="NOT_RECONCILED" ? (

                                                                                        reservation.status!="CANCELED"
                                                                                        ?
                                                                                        <span class="status-other">
                                                                                            { reservation.status && ((reservation.status.replace("_"," "))  )}
                                                                                        </span>
                                                                                        :

                                                                                        <span class="status-cancelled">
                                                                                            {'cancelled'}
                                                                                        </span>
                                                                                    )
                                                                                     : (
                                                                                        <>

                                                                                            <button
                                                                                                onClick={() => {
                                                                                                    console.log("apponitmentId for cancellationg", reservation.id)
                                                                                                    setCancelAppointmentId(reservation.id);
                                                                                                 }}
                                                                                            >
                                                                                                <i className="fas fa-times"></i>
                                                                                            </button>
                                                                                        </>
                                                                                    )}
                                                                                </div>




                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            );
                                                        })}
                                                    </>
                                                    :
                                                    <div className="no_reservation">
                                                        {t("events.no_reservation")}
                                                    </div>

                                            )
                                            :    
                                                <div className="no_reservation">
                                                    {t("events.error.error")}
                                                </div>
                                    )


                                }

                            </div>
                        </div>

                        <div class="row">
                            <div class="form-controls">
                                <button   
                                    disabled={! ( isFirstReservation() || ( props.myReservations && props.myReservations.length>0 ))}
                                    onClick={props.next}>
                                    {t("events.make_a_reservation")}
                                </button>
                            </div>
                        </div>

                       {cancelAppointmentId && (
                        <Event_CancelReservation
                            appointmentId={cancelAppointmentId}
                            handleDeleteReservation={handleDeleteReservation}
                            close={() => {
                                setCancelAppointmentId(null);
                             }}
                        />
                    )} 

                    </>




                </section>
            </section>

        }


    </>

    )
}
const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        serverTimeDate: state.store.home.serverTimeDate.date,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails
            ? state.store.home.clientConfig.currencyDetails.code
            : "",
        timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,


    }
}

const mapDispatchToProps = { setGoHome, closeOrderPopUp, sendAnalytics, popupOpenClose }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(Event2_MyReservations));
